<template>
  <ul v-if="visiblePaymentIcons.length" class="flex flex-wrap" :class="gapClasses[gap]">
    <li v-for="icon in visiblePaymentIcons" :key="icon.title">
      <PaymentMethodSymbol v-bind="{ outlined, size }" :variant="icon" />
    </li>
  </ul>
</template>

<script lang="ts" setup>
import type { PaymentMethodSymbolProps } from './PaymentMethodSymbol.vue'

type PaymentMethodSymbolsProps = Pick<PaymentMethodSymbolProps, 'outlined' | 'size'> & {
  gap?: keyof typeof gapClasses
  filter?: string[]
}

const gapClasses = {
  xs: 'gap-050',
  sm: 'gap-100',
  md: 'gap-200',
  lg: 'gap-x-300 gap-y-200',
} as const

const { gap = 'md', filter = [], outlined } = defineProps<PaymentMethodSymbolsProps>()

const visiblePaymentIcons = usePaymentIcons(filter)
</script>
